import store from 'store/index';

export const accessTokenInterceptor = {
  onConfig: (config) => {
    const accessToken = store?.getState()?.auth?.accessToken;
    // SwitchUser identifies the employee by the AuthToken cookie; a stale bearer must not be sent
    if (accessToken && !config.url?.endsWith('/SwitchUser')) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  onError: (error) => Promise.reject(error),
};
